export const defaultSchedulingColors = {
  work: '#2196F3',
  break: '#FCED65',
  timeOff: '#D5E8FF',
};
